var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{class:[
      _vm.order.attributes.order_type === 'sale'
        ? 'font-bold text-gray-900'
        : '',
    ]},[_vm._v(_vm._s(_vm.order.attributes.origin_code))]),_vm._v(" / "),_c('span',{class:[
      _vm.order.attributes.order_type === 'purchase'
        ? 'font-bold text-gray-900'
        : '',
    ]},[_vm._v(_vm._s(_vm.order.attributes.destination_code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }